import { Controller } from '@hotwired/stimulus'
import UserPreferences from 'models/user_preferences'
import gtag from 'utils/gtag'

// NOTE: This does not set up the OneTrust scripts. That's done in
// packs/marketing_web/app/views/shared/vendor_js_snippets/_onetrust_snippet.html.slim
// This controller is responsible for handling our own custom behavior, such as
// syncing consent settings to the backend.
export default class extends Controller {
  static values = { consentGroupMap: Object }

  async onConsentChanged(e) {
    // ",C0001,C0002"
    const consentGroupsString = e.detail.consentGroups
    // ["C0001","C0002"]
    const consentGroups = consentGroupsString.split(",").filter((str) => str !== "")

    const consentSettingsEntries = Object.keys(this.consentGroupMapValue).map((oneTrustKey) => {
      const ourKey = this.consentGroupMapValue[oneTrustKey]
      const value = consentGroups.indexOf(oneTrustKey) > -1 ? "granted" : "denied"
      return [ourKey, value]
    })

    /*
      {
        "C0001_necessary",: "granted",
        "C0002_performance",: "granted",
        "C0003_functional",: "denied",
        "C0004_targeting",: "denied",
        "C0005_social_media": "denied"
      }
    */
    const consentSettings = Object.fromEntries(consentSettingsEntries)

    // NOTE: OneTrust calls `gtag('consent', 'update') for us

    // Update our backend
    const preferences = new UserPreferences()
    await preferences.update("consent_mode", consentSettings)
  }
}
